import EventActionProto from '../../event-action-proto';

module.exports = class SessionMeetingUpdate extends EventActionProto {

    constructor(uid, data, sid, companyId, sessionEvent) {
        super(sessionEvent.uid, sessionEvent.data, sessionEvent.companyId)
        this.method     = sessionEvent.method
        this.header     = {
            reminder    : sessionEvent.data,
            isBulkUpdate: sessionEvent.isBulkUpdate,
        }
        this.fromSID    = sessionEvent.fromSID
    }

    process() {
        const reminderId = this.data.id

        // here we do 2 this
        // - update gd.session.reminders
        // - translate this event via bus so you get the update if needed i.e. have reminder open

        // session
        if (gd.session.reminders) {
            gd.session.reminders.update(reminderId, this.data, true)
        }

        gd.modelBus.newUpdate('reminder', 'delta', this.header.reminder.id, this.data, this.header)

        // do not process event for user who initialed update
        if (this.fromSID === gd.sessionId) {
            // console.log("same user -> ignore");
            return false
        }

        // Bus event triggers
        gd.bus.triggerEvent('reminder.{0}:update'.f(reminderId), this.data)

        super.process()
    }
}